import { Theme } from "@emotion/react";

export const theme = {
  colors: {
    white: "#FFFFFF",
    black: "#000000",
    orange: {
      0: "#e0d9ad",
      50: "#fcd100",
      100: "#f3b713",
      200: "#fc8f00",
    },
    gradient: {
      50: "#eb6106",
      100: "#db2b1d",
    },
    gray: {
      100: "#c8c8ca",
      350: "#dddddd",
      370: "#c0c0c0",
      380: "#e6e6e6",
      650: "#adadad",
      850: "#333333",
    },
    red: {
      100: "#ff4335",
      150: "#FF000F",
      200: "#BD161D",
    },
  },
  fontSize: {
    13: "13px",
    14: "14px",
    15: "15px",
    16: "16px",
    18: "18px",
    20: "20px",
    24: "24px",
    32: "32px",
    36: "36px",
    40: "40px",
    48: "48px",
    64: "64px",
    96: "96px",
  },
} as Theme;
